import { jsx as _jsx } from "react/jsx-runtime";
import { Flex } from "@radix-ui/themes";
import { forwardRef } from "react";
export const IconPanel = forwardRef(function IconPanel({ children, ...props }, ref) {
    return (_jsx(Flex, { ref: ref, width: "32px", height: "32px", align: "center", justify: "center", style: {
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "var(--gray-4)",
            borderRadius: "var(--radius-3)",
            backgroundColor: "var(--gray-2)",
        }, ...props, children: children }));
});
//# sourceMappingURL=icon-panel.js.map